import script from "./recipe-cost-calculator.vue?vue&type=script&setup=true&lang=js"
export * from "./recipe-cost-calculator.vue?vue&type=script&setup=true&lang=js"

import "./recipe-cost-calculator.vue?vue&type=style&index=0&id=79099808&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79099808"]])

export default __exports__